import type { ReactNode } from "react";

interface LockInfo {
  userId: number;
  userName: string;
  instanceId: string;
}

interface LiveFieldProps {
  lockedBy: LockInfo | null;
  children: ReactNode;
}

export function LiveField({ lockedBy, children }: LiveFieldProps) {
  if (!lockedBy) return <>{children}</>;

  return (
    <div className="relative">
      {children}
      <span className="absolute -top-2 right-1 text-[10px] bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded-full leading-none">
        {lockedBy.userName}
      </span>
    </div>
  );
}
